/* eslint-disable no-alert */
/* eslint-disable react-native/no-inline-styles */
import {Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {Alert, Linking, Platform, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {postCreateOnlinePayment} from '../../apis';
import {DRAWER_ROUTES} from '../../navigation/constants';
import {getSubjectNameById, px, useAsyncFn, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import {LoadingButton} from '../components';
import {PaymentErrorModal} from './PaymentErrorModal';

const Direct = ({
  navigation,
  kidId,
  packageId,
  selectedTimeTable,
  subjectNames,
  renewData,
  transactionId,
  monthNumber,
  isRenew,
  handleClosePaymentModal,
}) => {
  var isPaymentError = false;
  const isLandscape = useIsLandscape();
  const subjects = useSelector((state) => state.general.subjects);

  if (!isRenew) {
    if (
      selectedTimeTable &&
      selectedTimeTable.length > 0 &&
      selectedTimeTable[0].scheduleId
    ) {
      console.log('Proceess to payment');
    } else {
      isPaymentError = true;
    }
  }

  const [{loading: submitLoading}, handlePurchase] = useAsyncFn(async () => {
    if (!selectedTimeTable?.[0]?.scheduleId) {
      alert('Your payment session is expired, please try again!');
      if (isLandscape) {
        handleClosePaymentModal();
      }
      navigation.navigate(DRAWER_ROUTES.home.path);
      return;
    }

    try {
      const subjectNamesData = subjectNames
        ? subjectNames.replace(/ /g, '')
        : selectedTimeTable
            ?.map(({subjectId}) =>
              getSubjectNameById({id: subjectId, subjects}),
            )
            .join(',');

      var invoiceUrl = await postCreateOnlinePayment({
        kidId,
        packageId,
        selectedTimeTable,
        subjectNames: subjectNamesData,
        renewData,
        monthNumber,
      });

      if (Platform.OS === 'web') {
        window.location = invoiceUrl;
      } else {
        Linking.canOpenURL(invoiceUrl).then((supported) => {
          if (supported) {
            Alert.alert(
              'Payment',
              'You will be redirected to payment page, after payment completion close and reopen the app.',
              [
                {
                  text: 'OK',
                  onPress: () => {
                    Linking.openURL(invoiceUrl);
                    navigation.navigate(DRAWER_ROUTES.home.path);
                  },
                },
              ],
            );
          } else {
            console.log("Don't know how to open URI: " + invoiceUrl);
            window.location = invoiceUrl;
          }
        });
      }
    } catch (error) {
      alert(String(error));
      if (isLandscape) {
        handleClosePaymentModal();
      }
      navigation.navigate(DRAWER_ROUTES.home.path);
    }
  }, [kidId, packageId, selectedTimeTable, subjectNames, renewData]);

  return (
    <Layout>
      {renderIf(isPaymentError, <PaymentErrorModal />)}
      <LoadingButton
        loading={submitLoading}
        style={styles.button}
        onPress={handlePurchase}>
        {'Online Pay FPX'}
      </LoadingButton>
      <Text
        style={{
          fontWeight: '500',
          marginTop: 5,
          fontSize: 14,
          textAlign: 'center',
          marginHorizontal: 32,
        }}>
        {'Payment will be accepted immediately.'}
      </Text>
    </Layout>
  );
};

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  rowInput: {
    width: '50%',
  },
  button: {
    marginHorizontal: px(57),
  },
});

export default Direct;
